import { IPlayerMain } from '@avid/common';

import { ThunkAction } from 'typings';

import { pushLogThunk } from './logs.thunk';

export interface ILoadGameParams {
  roundNumber: number;
  bonus: Pick<IPlayerMain, 'energy' | 'money' | 'mood'>;
}

export const loadGameLogsThunk =
  (params: ILoadGameParams): ThunkAction =>
  (dispatch, getState) => {
    const { roundNumber, bonus } = params;

    const state = getState();

    const {
      app: { roundEnergy },
      player: {
        createCharacter: { performance },
      },
    } = state;

    const baseRoundEnergy = roundEnergy || undefined;

    dispatch(
      pushLogThunk({
        type: 'round',
        action: 'start',
        params: { round: roundNumber, energy: baseRoundEnergy },
      })
    );

    dispatch(
      pushLogThunk({
        type: 'bonus',
        action: 'get',
        params: {
          performance,
          energy: bonus.energy || undefined,
          money: bonus.money || undefined,
          satisfaction: bonus.mood || undefined,
        },
      })
    );
  };
